import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Search } from "lucide-react";

interface SEOLoadingStateProps {
  /**
   * The message to display below the loading spinner
   */
  message?: string;
}

/**
 * A consistent loading state component for SEO pages
 */
const SEOLoadingState: React.FC<SEOLoadingStateProps> = ({ 
  message = "We're analyzing your website. This may take a few moments."
}) => {
  return (
    <div className="container">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Search className="h-5 w-5 text-primary" />
            SEO Audit in Progress
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-8 space-y-6">
            <div className="relative w-20 h-20">
              <div className="absolute inset-0 rounded-full border-4 border-muted">
                <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-[spin_1s_linear_infinite]" />
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <Search className="h-6 w-6 text-primary" />
              </div>
            </div>

            <div className="text-center space-y-2">
              <h3 className="text-lg font-semibold">Analyzing Your Website</h3>
              <p className="text-sm text-muted-foreground max-w-md">
                {message}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SEOLoadingState;
